import Vue from 'vue';

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';

Vue.use(BootstrapVue, {
   BModal: {
      noEnforceFocus: true,
   },
   BTooltip: {
      delay: {
         show: 500,
         hide: 50,
      },
   },
});
Vue.use(IconsPlugin);
